import React from 'react';
import { useNavigate } from 'react-router-dom';

const ErrorPage = () => {
  const navigate = useNavigate();

  return (
    <div className="not-found">
      <div className="sweet-wrapper">
        <img
          src="/images/GBJ.png"
          alt="Gulab Jamun"
          className="sweet-image"
        />
        <img src="/images/Jalebi.png" alt="Jalebi" className="sweet-image" />
        <img src="/images/Barfi.png" alt="Barfi" className="sweet-image" />
      </div>
      <h1 className="heading">Oops! This page is sweeter than expected.</h1>
      <p className="message">
        Looks like you've reached a page that doesn't exist, but the sweetness
        continues at <b> Roop Sweets! </b>
      </p>
      <button className="home-button" onClick={() => navigate('/')}>
        Home
      </button>
    </div>
  );
};

export default ErrorPage;
